import set from 'lodash/set'

export default {
  set(state, { path, payload }) {
    set(state, path, payload)
  },
}
